<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Contact Pro'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      @for (pro of pros; track pro) {
        <tidy-card>
          <tidy-row>
            <tidy-grid>
              <ion-row>
                <ion-col size="6" class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/svg/person-circle-outline.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="pro?.first_name" />
                </ion-col>
                <!--TODO Replace this with a class-->
                @if (pro?.show_contact_buttons && !windowService.isDesktopRes) {
                  <ion-col size="3" style="text-align: right" class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/svg/call-outline.svg'"
                      class="body-size" />
                    <tidy-text
                      (action)="openTell(pro)"
                      [body]="'Call'"
                      class="link" />
                  </ion-col>
                }
                @if (pro?.show_contact_buttons && !windowService.isDesktopRes) {
                  <ion-col size="3" style="text-align: right" class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/svg/chatbox-ellipses-outline.svg'"
                      class="body-size" />
                    <tidy-text
                      (action)="openSms(pro)"
                      [body]="'Text'"
                      class="link" />
                  </ion-col>
                }
                @if (pro?.show_contact_buttons && windowService.isDesktopRes) {
                  <ion-col size="6">
                    <tidy-text
                      [body]="pro?.masked_phone_number" />
                  </ion-col>
                }
              </ion-row>
            </tidy-grid>
          </tidy-row>
          @if (pro?.show_contact_buttons) {
            <tidy-row class="extra-top-padding extra-bottom-padding">
              <tidy-divider />
            </tidy-row>
            <tidy-row>
              <tidy-text
                (action)="markNoShow(pro)"
                [body]="'Click here'"
                class="link" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'if'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="pro?.first_name" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'is not responding and did not show up.'" />
                  </tidy-row>
                }
              </tidy-card>
            }
            @if (!pro?.show_contact_buttons) {
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="'You can call / text your Pro once it is within 30 minutes of the job.'" />
              </tidy-row>
            }
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'To protect your privacy, we generate a temporary phone number for you to use for each job.'" />
            </tidy-row>
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Please use your phone number on file:'" /><br>
              <tidy-text
                [body]="(settings?.profile?.phone | telephone: 'format') + ' '" />
              <tidy-text
                [body]="'Edit'"
                (action)="goToEditContactInfo()"
                class="link" />
            </tidy-row>
          }

        </tidy-wrapper>
      </ng-template>

      <app-scroll-wrapper [templateContent]="content" />
